import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "student-grow"
};
var _hoisted_2 = {
  key: 0,
  class: "role-box"
};
var _hoisted_3 = {
  class: "iframe-content"
};
var _hoisted_4 = {
  key: 1,
  class: "empty-box"
};
import { ref, computed } from 'vue';
import IframeContainer from '@/components/IframeContainer/index.vue';
import emptyImage from '@/assets/home/dataReport/images/empty-icon.png';
export default {
  __name: 'StudentGrow',
  props: {
    auth: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var active = ref('student-grow-bloc');
    var typeOptions = [{
      label: '集团视角',
      value: 'student-grow-bloc'
    }, {
      label: '学校视角',
      value: 'student-grow-school'
    }];
    var permisOptions = computed(function () {
      var _props$auth;
      if ((_props$auth = props.auth) !== null && _props$auth !== void 0 && _props$auth.length) {
        var permis = typeOptions.filter(function (item) {
          return props.auth.some(function (itm) {
            return itm.permission === item.value;
          });
        });
        return permis || [];
      }
      return [];
    });
    console.log('permisOptions', permisOptions);
    return function (_ctx, _cache) {
      var _permisOptions$value, _permisOptions$value2;
      var _component_t_select = _resolveComponent("t-select");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_permisOptions$value = permisOptions.value) !== null && _permisOptions$value !== void 0 && _permisOptions$value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_t_select, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return active.value = $event;
        }),
        options: permisOptions.value
      }, null, 8, ["modelValue", "options"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [(_permisOptions$value2 = permisOptions.value) !== null && _permisOptions$value2 !== void 0 && _permisOptions$value2.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [active.value === 'student-grow-bloc' ? (_openBlock(), _createBlock(IframeContainer, {
        key: 0,
        src: "https://report.zhixuehuijiao.cn/webroot/decision/view/duchamp?viewlet=3922%252F3922_school.fvs&ref_t=design"
      })) : _createCommentVNode("", true), active.value === 'student-grow-school' ? (_openBlock(), _createBlock(IframeContainer, {
        key: 1,
        src: "https://report.zhixuehuijiao.cn/webroot/decision/view/duchamp?viewlet=3922%252F3922_school_grade.fvs&ref_t=design"
      })) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Empty, {
        icon: _unref(emptyImage),
        fullHeight: true
      }, {
        description: _withCtx(function () {
          return _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("div", {
            class: "empty-des"
          }, [_createElementVNode("p", null, "当前尚无任何数据权限"), _createElementVNode("p", null, "请找管理员进行应用授权范围设定")], -1)]));
        }),
        _: 1
      }, 8, ["icon"])]))])]);
    };
  }
};